import { render, staticRenderFns } from "./ScreenGuard.vue?vue&type=template&id=36c1275c&scoped=true&"
import script from "./ScreenGuard.vue?vue&type=script&lang=js&"
export * from "./ScreenGuard.vue?vue&type=script&lang=js&"
import style0 from "./ScreenGuard.vue?vue&type=style&index=0&id=36c1275c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c1275c",
  null
  
)

export default component.exports